<!--Page starts-->
<section id="maintenance">
    <div class="container-fluid">
        <div class="container">
            <div class="row full-height-vh">
                <div class="col-12 ml-auto d-flex justify-content-center align-items-center flex-column">
                    <p>
                        <img src="assets/img/logo_gp.png" />
                    </p>
                    <p class="error">
                        В настоящий момент на сайте проводятся реламентные работы.
                        Пожалуйста, зайдите через некоторое время. <br />
                        Приносим извинения за неудобства.
                    </p>
                    <p>
                        Подать обращения можно через:<br/>
                        <a href="https://epp.genproc.gov.ru/web/gprf/internet-reception" target="_blank">Интернет-приемную Генеральной прокуратуры Российской Федерации</a> <br />
                        <a href="https://t.me/ComplaintToVpBot" target="_blank"><i class="fa fa-telegram"></i> телеграм бота Главной военной прокуратуры</a>.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Page ends-->
